<template>
  <div class="flex w-full flex-col items-center gap-4">
    <div class="flex flex-col items-center justify-center">
      <span class="text-2xl"> Assinatura eletrônica </span>
      <span class="text-xs">
        Digite sua assinatura eletrônica de 4 digitos para confirmar esta ação:
      </span>
    </div>
    <ontick-pin-code-input-component
      :codelength="4"
      :value="value"
      @input="$emit('input', $event)"
    />
    <a class="text-xs hover:underline" href="#">
      Esqueceu sua assinatura eletrônica? Clique aqui
    </a>
  </div>
</template>

<script>
import ontickPinCodeInputComponent from "../../../shared/components/basic/ontick-pin-code-input.component.vue";
export default {
  components: { ontickPinCodeInputComponent },

  props: {
    value: { type: [Number, String] },
  },
};
</script>

<style></style>
